import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';


@Pipe({
  name: 'customdate',
})

export class CustomdatePipe implements PipeTransform {
  transform(value: string,keepTime :boolean) {
    console.log(typeof value,"type...............")
    if (typeof value === "undefined" || value === '0000-00-00 00:00:00') {
      return;
  } else if (typeof value ==="string") {
   
      let date;
    let hasTime = value.includes(':');
      if (!hasTime) {
          date = moment(value, 'YYYY-MM-DD');
      } else if (keepTime) {
          date = moment(value)
      } else {
  date = moment.utc(value).local()
      }
return date.toISOString()
  }
  //   if(value == "0000-00-00 00:00:00" || value == ""){
  //     return "";
  //   }
  //   if(value && typeof value == 'string'){
  //  return new Date(value).toISOString();
  //     // return new Date(value.replace(/-/g, "/"));
  //   }else{
  //     return value;
  //   }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/customdate/customdate.ts